import React from 'react';
import { Row } from 'react-bootstrap';
import IFormStep from 'interfaces/IFormStep';
import MemberDetailsBlock from '../Components/MemberDetailsBlock';
import Notice from '../Components/Notice';
import { LoadingSpinner } from 'components/LoadingSpinner';
import HelpButton from '../../../Form/HelpButton';

const YourDetails: React.FC<IFormStep> = ({ models, requirements }) => {
    if (models.loading) {
        return <LoadingSpinner />;
    }

    const help = requirements.config?.help && requirements.config?.help['yourDetails'];

    return (
        <>
            <Row className="col-8">
                <h2 className="fw-bold mb-3  fs-3">
                    Check your details{' '}
                    {help && <HelpButton title={'Your details'} content={help} />}
                </h2>
                <Notice>
                    <p>
                        Information accurate? If so please press 'Save and continue' below. If
                        anything is missing or inaccurate please update here, on the Coalesce
                        dashboard, and after that to click "Accreditation" on the left hand menu
                        then "Continue your application" button to resume.{' '}
                    </p>
                    <p>
                        For changes to Qualifications and Core Profession, please email{' '}
                        <a href={'mailto:membership@EMDRassociation.org'}>
                            membership@EMDRassociation.org
                        </a>{' '}
                        along with relevant proof (e.g. certificates).
                    </p>
                </Notice>
            </Row>
            <Row className={'col-8'}>
                <MemberDetailsBlock memberProfile={models.memberProfile} />
            </Row>
            <Row className="col-8">
                <Notice>
                    <p>
                        Information accurate? If so please press 'Save and continue' below. If
                        anything is missing or inaccurate please update here, on the Coalesce
                        dashboard, and after that to click "Accreditation" on the left hand menu
                        then "Continue your application" button to resume.
                    </p>
                    <p>
                        For changes to Qualifications and Core Profession, please email{' '}
                        <a href={'mailto:membership@EMDRassociation.org'}>
                            membership@EMDRassociation.org
                        </a>{' '}
                        along with relevant proof (e.g. certificates).
                    </p>
                </Notice>
            </Row>
        </>
    );
};

export default YourDetails;
